import type { PlayerController } from '../movement/PlayerController';
import type { StrafeSync } from './strafeSync';

/** F3 overlay: what the physics is doing right now. */
export class DebugHud {
  private readonly el: HTMLElement;
  visible = false;

  constructor(parent: HTMLElement) {
    this.el = document.createElement('div');
    this.el.id = 'debug-hud';
    this.el.style.display = 'none';
    parent.appendChild(this.el);
  }

  toggle(): void {
    this.visible = !this.visible;
    this.el.style.display = this.visible ? 'block' : 'none';
  }

  update(player: PlayerController, sync: StrafeSync): void {
    if (!this.visible) {
      return;
    }
    const p = player.position;
    const v = player.velocity;
    const state = player.grounded ? 'ground' : player.surfing ? 'surf' : 'air';
    const syncPct = sync.percent();
    this.el.textContent = [
      `state  ${state}`,
      `hspeed ${player.horizontalSpeed().toFixed(0)} u/s`,
      `vel    ${v.x.toFixed(0)} ${v.y.toFixed(0)} ${v.z.toFixed(0)}`,
      `pos    ${p.x.toFixed(0)} ${p.y.toFixed(0)} ${p.z.toFixed(0)}`,
      `sync   ${syncPct === null ? '--' : `${syncPct}%`}`,
    ].join('\n');
  }
}
